import { Injectable } from '@angular/core';
import { map, of } from 'rxjs';
import { ResourceName } from '../../../../../backend/src/core/resource-name';
import { DeepgramGate } from './../../../../../backend/src/core/deepgram/deepgram.gate';
import { LambdaService } from './../../shared/core/lambda.service';

@Injectable({
  providedIn: 'root',
})
export class DeepgramService {
  private interviewIdAndApiKey = new Map<string, string>();

  constructor(private lambdaService: LambdaService) {}

  getTempApiKeyForInterview$(interviewId: string) {
    if (this.interviewIdAndApiKey.has(interviewId)) {
      return of(this.interviewIdAndApiKey.get(interviewId));
    }

    return this.lambdaService
      .run$(ResourceName.deepgram, DeepgramGate.actions.getTempApiKeyForInterview, {
        interviewId,
      })
      .pipe(
        map((result) => {
          this.interviewIdAndApiKey.set(interviewId, result);
          return result;
        })
      );
  }
}
